import React from "react";
import {
  gridPageCountSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import MuiPagination from "@mui/material/Pagination";
import { Avatar, Tooltip } from "@mui/material";
import dayjs from "dayjs";

const CustomPagination = ({ page, onPageChange, className }) => {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      color="primary"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
};

// Custom Pagination for DataGrid Table
export const DataGridCustomPagination = (props) => {
  return <GridPagination ActionsComponent={CustomPagination} {...props} />;
};

export const states = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "American Samoa", value: "AS" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Northern Mariana Isla", value: "MP" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virgin Islands", value: "VI" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "Washington D.C.", value: "DC" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const timeZoneArray = ["EST", "CST"];

export const isoDateFormatter = (date) => {
  console.log("date: ", date, dayjs(date).format("YYYY-MM-DD"));
  // To convert date to yyyy-mm-dd format
  if (typeof date === "string") date = fixDate(date);
  if (date) return dayjs(date).format("YYYY-MM-DD");
  return null;
};

export const jsDateFormatter = (dateString) => {
  if (!dateString) return null;
  // alert("in jsDateFormatter string is " + dateString)
  let newDate = new Date(dateString);
  // Fix offset
  newDate = new Date(
    newDate.getTime() + Math.abs(newDate.getTimezoneOffset() * 60000),
  );
  if (!isNaN(newDate.getTime())) return newDate;
  return null;
};

// to fix if date goes back by one day
export const fixDate = (date) => {
  if (!date) return null;
  if (typeof date === "string") return new Date(date.substring(0, 16));
  let newDate = new Date(date);
  return new Date(
    newDate.getTime() + Math.abs(newDate.getTimezoneOffset() * 60000),
  );
};

export const displayDateFormatter = (date, yymmddMode, ddmmyyyMode) => {
  // To convert date to mm/dd/yyyy format to display on UI
  if (!date) return null;
  try {
    let newDate = date;
    if (typeof date === "string") newDate = new Date(date.substring(0, 16));

    // let newDate = new Date(date);
    // To fix the offset in time //
    // let newDate = new Date( newDate.getTime() + Math.abs(newDate.getTimezoneOffset()*60000));
    //alert("Date after offset is " + newDate)
    if (yymmddMode) {
      let res = dayjs(newDate).format("YYYY/MM/DD");
      let result = res.split("/").join("-");
      return result;
    }
    const correctedDate = fixDate(newDate);
    return dayjs(correctedDate).format(
      ddmmyyyMode ? "DD/MM/YYYY" : "MM/DD/YYYY",
    );
  } catch (e) {
    console.log("ERROR", e);
  }
  return null;
};

export const checkStringValue = (data) => {
  if (data) return data;
  return "";
};

export const getEnv = () => {
  const host = window.location.host.split(":")[0];
  if (host === "billing-web.services.orcicare.com") {
    return "prod";
  }
  if (host === "billing-web-test.services.orcicare.com") {
    return "test";
  }
  return "local";
};

export const timerTimeFormatter = (timer) => {
  const getSeconds = `0${timer % 60}`.slice(-2);
  const minutes = `${Math.floor(timer / 60)}`;
  const getMinutes = `0${minutes % 60}`.slice(-2);
  const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);

  return `${getHours} : ${getMinutes} : ${getSeconds}`;
};

export const convertToMMDDYY = (date) => {
  if (!date) return "";

  const [year, month, day] = date.split("-");

  return `${month}/${day}/${year}`;
};

export const parseSafely = (string) => {
  if (isNaN(parseFloat(string))) return 0;
  return parseFloat(string);
};

export const displayCost = (number) => {
  if (!number && number !== 0) return "N/A";
  if (typeof number === "string") number = parseFloat(number);
  if (isNaN(number)) return "--";
  const num = number || 0;
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  const cost = Number(num).toLocaleString("en", options);
  return "$ " + cost;
};

export const AMPMTime = (date) => {
  if (!date) return "";
  if (typeof date === "string") date = new Date(date.substring(0, 25));
  if (isNaN(date.getTime())) return "";
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  const strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

export const displayEmptyValue = (string, type) => {
  if (string) return string;
  return type || "N/A";
};

export const displayAddress = ({ address1, address2, city, state, zip }) => {
  const addComma = (value) => (value ? `${value}, ` : "");
  return `${addComma(address1)}${addComma(address2)}${addComma(city)}${
    state ? state + " - " : ""
  }${zip || ""}`;
};

// Retries lazy loading if component failed to load
export function componentLoader(lazyComponent, attemptsLeft = 3) {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        // let us retry after 1500 ms
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1).then(
            resolve,
            reject,
          );
        }, 1500);
      });
  });
}

export const getStripeKey = () => {
  if (getEnv() === "prod") {
    return "pk_live_51JF9ldB4dGMT36K4vZwyHZrvAlHtx0XkvjanLenooT37b1aIPZG3YwYLVNdbWkVGZLjmidWCKzmm1ThA6hfW9dCr00ulNQwOsM";
  }
  return "pk_test_51JF9ldB4dGMT36K4Jq144SUYh67mYDnPflkWbAWNjBoMjjYwvLikRY9MPuTTuIL3aXPi4pIdaOnOHPZtqdq9g3zN00eytcYQyN";
};

export const open_billing_charge_entry = ({ patient_id, charge_entry_id }) => {
  if (!patient_id || !charge_entry_id) return;
  const params = `charge-entry/${patient_id}/${charge_entry_id}`;
  const env = getEnv();
  if (env === "prod") {
    window.open(
      "https://billing-web.services.orcicare.com/" + params,
      "_blank",
    );
  } else if (env === "test") {
    window.open(
      "https://billing-web-test.services.orcicare.com/" + params,
      "_blank",
    );
  } else {
    window.open("http://localhost:3000/" + params, "_blank");
  }
};

export function GetAvatar({ text }) {
  return (
    <Tooltip title={text}>
      <Avatar
        sx={{
          width: 30,
          height: 30,
          fontSize: 14,
          backgroundColor: "#9cdce7",
          color: "#454545",
        }}
      >
        {text.slice(0, 2).toUpperCase()}
      </Avatar>
    </Tooltip>
  );
}

export const isValidDate = function (date) {
  // eslint-disable-next-line no-constant-binary-expression
  return new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};

export const userClamisHeaders = [
  { label: "ID", key: "charge_entry_id" },
  { label: "Status Age", key: "status_age" },
  { label: "Patient Name", key: "patient_name" },
  { label: "Charge Entry Status", key: "charge_entry_status" },
  { label: "DOB", key: "dob" },
  { label: "DOS", key: "service_date" },
  { label: "Sequence", key: "claim_sequence" },
  { label: "Payer Name", key: "payer_name" },
  { label: "Message", key: "message" },
  { label: "Assigned User", key: "assigned_user_name" },
];

export const dashboardHeaders = [
  { label: "ID", key: "charge_entry_id" },
  { label: "Practice patient Id", key: "practice_patient_id" },
  { label: "Patient Name", key: "patient_name" },
  { label: "DOB", key: "dob" },
  { label: "DOS", key: "service_date" },
  { label: "Status", key: "status" },
  { label: "Payer Name", key: "payer_name" },
  { label: "Billed Amt", key: "total_billed_amt" },
  { label: "Assigned User", key: "assigned_user_name" },
  { label: "Age", key: "status_age" },
  { label: "Associated Tags", key: "tags" },
];

export const dashboardExportingHeaders = [
  { label: "ID", key: "charge_entry_id" },
  { label: "Practice patient Id", key: "practice_patient_id" },
  { label: "Patient Name", key: "patient_name" },
  { label: "DOB", key: "dob" },
  { label: "DOS", key: "service_date" },
  { label: "Status", key: "status" },
  { label: "Status Change Prev Status", key: "status_chg_prev_status" },
  { label: "Payer Name", key: "payer_name" },
  { label: "Created Date", key: "created_dt" },
  { label: "Updated Date", key: "last_updated_status_date" },
  { label: "Last Updated By", key: "last_updated_by" },
  { label: "Last Updated Date", key: "last_updated_date" },
  { label: "Billed Amt", key: "total_billed_amt" },
  { label: "Assigned User", key: "assigned_user_name" },
  { label: "Age", key: "status_age" },
  { label: "Associated Tags", key: "tags" },
];

export const eraHeaders = [
  { label: "View ERA", key: "s3_url" },
  { label: "ERA Id", key: "id" },
  { label: "NPI", key: "provider_npi" },
  { label: "Provider", key: "provider_name" },
  { label: "Payer", key: "payer_name" },
  { label: "Payer id", key: "payer_id" },
  { label: "Payment Method", key: "payment_method" },
  { label: "Paid amt", key: "paid_amount" },
  { label: "Paid Date", key: "paid_date" },
  { label: "Received Date", key: "received_date" },
  { label: "Checked no", key: "check_number" },
];

export const eraClaimsHeaders = [
  { label: "View ERA", key: "s3_url" },
  { label: "ERA Id", key: "era_id" },
  { label: "ERA Claim Id", key: "era_claim_id" },
  { label: "Charge Entry Id", key: "charge_entry_id" },
  { label: "Patient Name", key: "patient_name" },
  { label: "Payer id", key: "payer_id" },
  { label: "Payment Method", key: "payment_method" },
  { label: "Charge Total", key: "charge_total" },
  { label: "Allowed Total", key: "allowed_total" },
  { label: "Adjusted Total", key: "adjusted_total" },
  { label: "Paid Total", key: "paid_total" },
  { label: "Patient Resp Total", key: "patient_resp_total" },
  { label: "Paid Date", key: "paid_date" },
  { label: "Received Date", key: "received_date" },
  { label: "Checked no", key: "check_number" },
];
